// Fixed Sidebar scrolling
var fixedAside = $('.js-sidebar-fixed');

if ( fixedAside.length > 0 ) {
    var bottomPosition = $('#headTen').offset().top - 250;
    $(window).scroll(function () {
        var scrollPosition = $(this).scrollTop();
        var currentPosition = $(this).scrollTop();

        if ( scrollPosition <= bottomPosition ) {
            fixedAside.addClass('aside_fixed');
            if ( currentPosition >= bottomPosition ) {
                fixedAside.css('top', bottomPosition);
            }
            else {
                fixedAside.css('top', currentPosition);
            }
        } else {
            fixedAside.removeClass('aside_fixed');
            if ( scrollPosition < 10 ) {
                fixedAside.css('top', 0);
            }
        }
    });

    // scrolling to id faq page
    $('.js-sidebar-fixed .sidebar__link[href^="#"]').on('click', function (event) {
        event.preventDefault();
        $('html').animate({
            scrollTop: $($(this).attr('href')).offset().top - 20
        }, 600);
    });
}